import axios from 'axios';
import injected from '../injected';

export var instance = axios.create({
  baseURL: injected.BACKEND_URL
});
//# sourceMappingURL=instance.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/utils/instance.js
// module id = 304
// module chunks = 0